import styled from "styled-components";
import Fundo from '../img/Sobre_Empresa.png';

export const DivSobre = styled.div`
    position: relative;
    margin: 2vh auto 0;
    width: 85.9%;
    aspect-ratio: 1920 / 962;
    overflow: hidden;
    border-radius: 6px;
    border: 2px solid #d5d5d5;
    box-sizing: border-box;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background-color: #E4E3E0;
    background-image: url(${Fundo});
    background-size: cover;
    background-position: bottom right;
    background-repeat: no-repeat;

    .conteudo {
        position: absolute;
        inset: 0;
        padding: 15% 5% 5%;
        box-sizing: border-box;
    }

    .lente {
        display: inline-block;
        max-width: 62%;
        padding: 1.5vw 2vw;
        border-radius: 0.8vw;
        background: rgba(255, 255, 255, 0.72);
    }

    h1 {
        margin: 0 0 5% 0;
        font-size: 2.6vw;
        font-weight: 900;
        color: #171717;
    }

    .texto {
        font-size: 1.25vw;
        line-height: 1.55;
        color: #262626;
        font-weight: 500;
        text-align: justify;
    }

    @media screen and (max-width: 750px) {
        aspect-ratio: auto;
        width: 100%;
        margin: 0px;
        border-radius: 0px;
        background-image: none;

        .conteudo {
            position: static;
            padding: 6vw 5vw;
        }

        .lente {
            display: block;
            max-width: 100%;
            padding: 4vw;
        }

        h1 {
            font-size: 6vw;
            margin-bottom: 4vw;
            text-align: center;
        }

        .texto {
            max-width: 100%;
            font-size: 3.6vw;
        }
    }
`;
